module.exports = __webpack_public_path__ + "img/user.ba47513c.svg";